export const CREATE_INVITATION = 'createInvitation';
export const CREATE_INVITATIONS = 'createInvitations';
export const FETCH_INVITATION_FROM_LINK = 'fetchInvitationFromLink';
export const FETCH_WORKSPACE_INVITATIONS = 'fetchWorkspaceInvitations';
export const FETCH_PENDING_WORKSPACE_INVITATIONS = 'fetchPendingWorkspaceInvitations';
export const FETCH_PENDING_USER_INVITATIONS = 'fetchPendingUserInvitations';
export const FETCH_USER_INVITATIONS = 'fetchUserInvitations';
export const FETCH_INVITATION_BY_ID = 'fetchInvitationById';
export const FETCH_INVITATIONS_BY_TEAM_ID = 'fetchInvitationsByTeamId';
export const ACCEPT_INVITATION = 'acceptInvitation';
export const VOID_INVITATION_BY_ID = 'voidInvitationById';
